import React, { useState, useMemo } from 'react';
import { Button, Loader, Modal } from '../../../../Components/uielements';
import { ModalLabel } from '../user.style';
import {
  OutlineButton,
  ModalButtonWrapper,
  ModalWrapper,
  ModalGap,
} from '../../../../services/settings/appStyle/global.style';
// import { useUserContext } from '../../../../hooks/UserContext';
import CompanyService from '../../../../services/bioplus-services/company';
import DropDown from '../../../../Components/uielements/dropDown';
import { IntlMessages } from '../../../../helper/langHelper';
import { useQuery } from 'react-query';
// import { getUnassignedPremisesOfACompany } from '../../../../services/bioplus-services/permise-permission';
import { ReactMultiEmail } from 'react-multi-email';
import './style.css';
import styled from 'styled-components';
import InviteResultModal from './InviteResultModal';
import { getCustomRoleList } from '../../../../services/bioplus-services/user';

const EmailContainer = styled.div`
  margin: 16px 0;
`;

const EmailLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;

const InviteUserModal = ({ onClose, companyId }) => {
  // const userContext = useUserContext();
  const [error, setError] = useState();
  const [errors, setErrors] = useState({});
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  // const [assignedPremise, setAssignedPremise] = useState(undefined);
  const [emails, setEmails] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  // const [unAssignedPremisesOfCompany, setUnAssignedPremisesOfCompany] = useState([]);
  const [inviteData, setInviteData] = useState(null);

  const { data: customRoles = [], isLoading: rolesLoading } = useQuery(
    ['customRoleList', companyId],
    () => getCustomRoleList({ companyId }),
    {
      enabled: !!companyId,
    }
  );

  // COMMENTED OUT - Fetch unassigned premises based on selected role (for future use)
  // const { data: unAssignedPremisesOfCompany = [], isLoading: premisesLoading } = useQuery(
  //   ['unAssignedPremises', companyId, selectedRoleId],
  //   () => getUnassignedPremisesOfACompany(companyId),
  //   {
  //     enabled: !!companyId && !!selectedRoleId && isSecureRole,
  //     onSuccess: (data) => {
  //       setUnAssignedPremisesOfCompany(data ?? []);
  //     },
  //   }
  // );

  const selectedRoleObject = useMemo(() => {
    return customRoles.find((role) => role._id === selectedRoleId);
  }, [selectedRoleId, customRoles]);

  const isSecureRole = selectedRoleObject?.secure === 1;

  const roleOptions = customRoles.map((role) => ({
    label: role.label,
    value: role._id,
  }));

  // const premiseOptions = unAssignedPremisesOfCompany?.map((item) => ({
  //   label: item?.premiseName,
  //   value: item.premiseId,
  // })) ?? [];

  const handleGenerateInvite = async () => {
    if (!selectedRoleId) {
      setErrors({ ...errors, roleId: 'Please select a role' });
      return;
    }

    if (isSecureRole) {
      if (emails.length === 0) {
        setErrors({ ...errors, emails: 'Please add at least one email address' });
        return;
      }
    }

    // if (selectedRole === 'MANAGER') {
    //   if (!assignedPremise) {
    //     setError('Please select a property for manager role');
    //     return;
    //   }
    // }

    const payload = {
      customRoleId: selectedRoleId,
      ...(isSecureRole && { emailArray: emails }),
      // ...(assignedPremise && { premiseId: assignedPremise }),
    };

    try {
      setIsProcessing(true);
      setError(null);
      const response = await CompanyService.inviteUser(companyId, payload);

      setInviteData(response?.data || response);
      setIsProcessing(false);
    } catch (e) {
      setIsProcessing(false);
      setError(e?.response?.data?.message || 'Failed to generate invite');
    }
  };

  const handleSelectedRole = (value) => {
    setSelectedRoleId(value.value);
    // setAssignedPremise(undefined);
    setEmails([]);
    setError(null);
  };

  // const handleAssignedPremise = (value) => {
  //   setAssignedPremise(value?.value);
  // };

  if (inviteData) {
    return <InviteResultModal inviteData={inviteData} onClose={onClose} />;
  }

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title="Invite Members" overFlowVisible={true}>
        {!error ? (
          <ModalWrapper style={{ marginBottom: '20px', maxWidth: '600px' }}>
            <ModalGap>
              <DropDown
                options={roleOptions}
                selectedOption={handleSelectedRole}
                defaultValue={'Select Role'}
                label="Role"
                disabled={rolesLoading}
              />
              {errors.roleId && (
                <ModalLabel style={{ color: '#f44336' }}>{errors.roleId}</ModalLabel>
              )}
              {/* {isSecureRole && (
                <>
                  <DropDown
                    options={premiseOptions}
                    selectedOption={handleAssignedPremise}
                    defaultValue={'Select the Property'}
                    label="Assign Property"
                    disabled={premisesLoading}
                  />
                </>
              )} */}
            </ModalGap>

            {isSecureRole && (
              <EmailContainer>
                <EmailLabel>Email Addresses</EmailLabel>
                <ReactMultiEmail
                  placeholder="Input your email..."
                  emails={emails}
                  onChange={(newEmails) => setEmails(newEmails)}
                  getLabel={(email, index, removeEmail) => (
                    <div data-tag key={index}>
                      <div data-tag-item>
                        {email}
                        <span data-tag-handle onClick={() => removeEmail(index)}>
                          ×
                        </span>
                      </div>
                    </div>
                  )}
                />
                {errors.emails && (
                  <ModalLabel style={{ color: '#f44336' }}>{errors.emails}</ModalLabel>
                )}
              </EmailContainer>
            )}

            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>Close</OutlineButton>
              {isProcessing ? (
                <Button varient="normal" disabled={isProcessing}>
                  <div style={{ paddingRight: '10px' }}></div>
                  <IntlMessages id="button.text.processing" />
                  <Loader size="small" isNotRequiredLoadingText={true} />
                </Button>
              ) : (
                <Button varient="normal" onClick={handleGenerateInvite} disabled={rolesLoading}>
                  Generate Invite
                </Button>
              )}
            </ModalButtonWrapper>
          </ModalWrapper>
        ) : (
          <ModalWrapper>
            <ModalLabel style={{ color: '#f44336' }}>{error}</ModalLabel>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>Close</OutlineButton>
              <Button varient="normal" onClick={() => setError(null)}>
                Try Again
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        )}
      </Modal>
    </>
  );
};

export default InviteUserModal;
